module.exports = "/_next/static/files/0d4762ef662f07931fa88555b5f06364.jpg";